import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "info-overlay" }
const _hoisted_2 = { class: "info-overlay__content" }

import { onMounted, ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'DataPrivacyOverlayComponent',
  emits: ["toggleOverlay"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const onCloseOverlay = () => {
  emit('toggleOverlay', false);
};

const closeButton = ref(null);

onMounted(() => {
    (closeButton.value! as HTMLElement).focus();
});

window.addEventListener('keydown', (e) => {
  if(e.key === 'Escape') {
    onCloseOverlay();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("h2", null, "Hinweise zum Datenschutz", -1)),
      _cache[1] || (_cache[1] = _createElementVNode("p", null, " Wir speichern deine E-Mail-Adresse zum Zweck der Kontaktaufnahme. Wir teilen die Informationen nicht mit Dritten und löschen Sie im Anschluss an die Kontaktaufnahme umgehend. ", -1)),
      _cache[2] || (_cache[2] = _createElementVNode("p", null, " Unser Webserver speichert im Rahmen des E-Mail-Versands Logdateien mit den Zugriffen und den IP-Adressen der Zugreifenden. Abgesehen davon werden keine Daten erhoben, gespeichert oder ausgewertet. ", -1)),
      _createElementVNode("button", {
        class: "button",
        onClick: onCloseOverlay,
        ref_key: "closeButton",
        ref: closeButton
      }, "Schließen", 512),
      _createElementVNode("button", {
        class: "close",
        onClick: onCloseOverlay
      }, "×")
    ])
  ]))
}
}

})